import { Config } from '../../config'

export const ecomConfig: Config = {
  partner: 'ecom',
  catalog: 'partner',
  displayName: 'E Com',
  accentColor: '#47538a',
  host: 'ecomseating.com',
  extraAttributes: {
    hideQuoteRequest: true,
  }
}
